import { createFileRoute } from '@tanstack/react-router';
import { SEO } from 'components/Seo/Seo';
import { useSelector } from 'react-redux';
import { RootState } from 'store/reducer';
import { rewardsApi } from 'store/slices/rewards-api';
import { preloadQueries } from 'utils/preloading';
import RewardsView from './components/RewardsView';
import messages from './messages';

export const Route = createFileRoute('/_authenticated/rewards')({
  component: Rewards,
  loader: async () => {
    await preloadQueries(
      rewardsApi.endpoints.getRewardDetails.initiate(),
      rewardsApi.endpoints.getRewardTiers.initiate(),
    );
  },
});

function Rewards() {
  const { language } = useSelector(
    (rootState: RootState) => rootState.language,
  );

  const seoMessages = messages[language].seo;

  return (
    <>
      <SEO
        title={seoMessages.title}
        description={seoMessages.description}
        keywords={seoMessages.keywords}
        page="rewards"
      />
      <RewardsView />
    </>
  );
}
